import { layoutHero, placeMarker } from "./hero_layout";

async function getImageAspectRatio(img) {
  if (!(img instanceof HTMLImageElement)) {
    throw new Error("Argument must be an HTMLImageElement");
  }
  const computeRatio = () => img.naturalWidth / img.naturalHeight;

  if (img.complete && img.naturalWidth) {
    return computeRatio();
  }

  return new Promise((resolve, reject) => {
    img.addEventListener("load", () => resolve(computeRatio()), { once: true });
    img.addEventListener(
      "error",
      () => reject(new Error("Image failed to load")),
      { once: true }
    );
  });
}

const setupHero = async (heroEl) => {
  if (!heroEl) {
    return;
  }

  const heroMarkers = [...heroEl.querySelectorAll(".js-hero-marker")];
  const heroBg = heroEl.querySelector(".js-hero-background");

  if (!heroBg) {
    return;
  }

  const aspectRatio = await getImageAspectRatio(heroBg);

  const debugTl = heroEl.querySelector(".js-hero-debug-tl");
  const debugTr = heroEl.querySelector(".js-hero-debug-tr");
  const debugBr = heroEl.querySelector(".js-hero-debug-br");
  const debugBl = heroEl.querySelector(".js-hero-debug-bl");
  const debugCenter = heroEl.querySelector(".js-hero-debug-center");

  const target = {
    left: +heroEl.dataset.targetLeft,
    top: +heroEl.dataset.targetTop,
    height: +heroEl.dataset.targetHeight,
    width: +heroEl.dataset.targetWidth,
  };

  const section = heroEl.closest(".js-swiper");
  const header = document.querySelector(".js-hero-header");
  const below = [
    section?.querySelector(
      `.js-swiper-visibility-item[data-visibility-index="${heroEl.dataset.slideIndex}"]`
    ),
    section?.querySelector(".js-swiper-nav-container"),
  ].filter(Boolean);

  const measureBand = () => {
    const hero = heroEl.getBoundingClientRect();
    return {
      top: header
        ? Math.max(header.getBoundingClientRect().bottom - hero.top, 0)
        : 0,
      bottom: Math.min(
        hero.height,
        ...below.map((el) => el.getBoundingClientRect().top - hero.top)
      ),
    };
  };

  const resize = () => {
    const { image, target: box } = layoutHero({
      width: heroEl.clientWidth,
      height: heroEl.clientHeight,
      band: measureBand(),
      aspectRatio,
      target,
    });

    heroBg.style.setProperty("--bg-top", `${image.top}px`);
    heroBg.style.setProperty("--bg-left", `${image.left}px`);
    heroBg.style.setProperty("--bg-height", `${image.height}px`);
    heroBg.style.setProperty("--bg-width", `${image.width}px`);

    debugTl.style.left = `${box.left}px`;
    debugTl.style.top = `${box.top}px`;

    debugTr.style.left = `${box.left + box.width}px`;
    debugTr.style.top = `${box.top}px`;

    debugBr.style.left = `${box.left + box.width}px`;
    debugBr.style.top = `${box.top + box.height}px`;

    debugBl.style.left = `${box.left}px`;
    debugBl.style.top = `${box.top + box.height}px`;

    for (const marker of heroMarkers) {
      const { left, top } = placeMarker(box, {
        left: +marker.dataset.markerLeft,
        top: +marker.dataset.markerTop,
      });

      marker.style.setProperty("--marker-left", `${left}px`);
      marker.style.setProperty("--marker-top", `${top}px`);

      marker.style.opacity = 1;
    }

    heroBg.style.opacity = 1;
  };

  const observer = new ResizeObserver(resize);
  [heroEl, header, ...below].filter(Boolean).forEach((el) => observer.observe(el));

  //window.addEventListener("resize", resize);

  resize();
};

document.addEventListener("page:load", () => {
  const markerBtns = document.querySelectorAll(".js-hero-marker-btn");
  const markers = document.querySelectorAll(".js-hero-marker");

  for (const markerBtn of markerBtns) {
    markerBtn.addEventListener("click", function () {
      const marker = this.closest(".js-hero-marker");
      const popover = marker.querySelector(".js-hero-marker-popover");

      const isOpen = marker.classList.contains("js-hero-marker--open");

      for (const item of markers) {
        item.classList.remove("js-hero-marker--open");
        const popover_ = item.querySelector(".js-hero-marker-popover");

        if (popover_?.classList?.contains("js-hero-marker-popover--shown")) {
          popover_.classList.remove("js-hero-marker-popover--shown");
          popover_.hidePopover();
        }
      }

      if (!isOpen) {
        marker.classList.add("js-hero-marker--open");

        if (popover?.showPopover) {
          popover.classList.add("js-hero-marker-popover--shown");
          popover.showPopover();
        }
      }
    });
  }

  window.addEventListener("click", (e) => {
    if (
      e.target.closest(".js-hero-marker--open") ||
      e.target.classList.contains("js-hero-marker--open")
    ) {
      return;
    }

    for (const item of markers) {
      item.classList.remove("js-hero-marker--open");
    }
  });

  const heroEls = document.querySelectorAll(".js-hero-markers");

  for (const heroEl of heroEls) {
    setupHero(heroEl);
  }
});
